export default "/accountant-head.e4ee9e8a8df1938bd3d9740ec815a5d8.png";